export const theme = {
  white: 'hsl(0, 100%, 100%)',
  black: 'hsl(0, 0%, 0%)',
  grey: `hsl(0, 0%, 97%)`,
  red: 'hsl(0, 100%, 50%)',
  high: '#e74c3c',
  medium: '#E0A800',
  low: '#2ecc71',
  details: '#ddd',
  home: '#ddd',
  regular: 300,
  bold: 600,
  fontSize: {
    xxs: '1rem',
    xs: '1.2rem',
    s: '1.6rem',
    m: '2.1rem',
    l: '2.4rem',
    xl: '4rem',
  },
};
